/* This file is autogenerated, see readme.md for instructions */
import CodeSvgIcon from '@bloomreach/banana-theme/icons/code.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const CodeIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <CodeSvgIcon />
    </Icon>
  );
});

CodeIcon.displayName = 'CodeIcon';

export default CodeIcon;
